/* eslint-disable jsx-a11y/anchor-is-valid */
import { yupResolver } from '@hookform/resolvers/yup'
import { FC, useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { KTCard } from '../../../../../../../_metronic/helpers'
import SelectWrapper from '../../../../../components/UI/Form/Input/selectWrapper'
import { Button, ButtonWrapper } from '../../../../../components/UI/Button'
import { useKhipu } from '../../../../../hooks/useKhipu'
import { SelectOption } from '../../../../../models/utility.model'
import * as Yup from 'yup'
import { useCentralServices } from '../../../hooks/useCentralServices'
import { useModules } from '../../../hooks/useModules'
import { getListCamasPreferentesService, downloadCamasPreferentesExcelService } from '../../../services/booking.service'
import { TableReportCamasPreferentes } from './Tables/TableReportCamasPreferentes'
import { getSnackBarToast } from '../../../../../util/snackBar'

const reportCamasPreferentesSchema = Yup.object().shape({
  CampamentoId: Yup.string().required('Campamento es requerido'),
})

const ReportCamasPreferentes: FC = () => {
  const methods = useForm({
    resolver: yupResolver(reportCamasPreferentesSchema),
    defaultValues: {
      CompaniaId: '',
      ClienteId: '',
      SiteId: '',
      CampamentoId: '',
      ModuloId: '',
    },
  })
  const {
    setValue,
    handleSubmit,
    setError,
    watch,
    reset,
  } = methods
  const [compani, setCompany] = useState<SelectOption[]>([])
  const [client, setClient] = useState<SelectOption[]>([])
  const [site, setSite] = useState<SelectOption[]>([])
  const [camp, setCamp] = useState<SelectOption[]>([])
  const [modules, setModules] = useState<SelectOption[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [dataTable, setDataTable] = useState<any[]>([])
  const [total, setTotal] = useState<number>(0)
  const [dtoToSend, setDtoToSend] = useState<any>()

  const { searchValues } = useKhipu()

  const { getModules } = useModules()
  const { getCompanies, getClients, getSites, getCamps } = useCentralServices()

  const getCompaniesFn = async () => {
    const data = await getCompanies({ isCombo: true }, 1)
    if (data.length === 1) {
      setValue('CompaniaId', data[0].value as string)
      setError('CompaniaId', {})
      await getClientsFn(data[0].value as string)
    }
    setCompany(data)
  }

  const getClientsFn = async (companyId: string) => {
    const data = await getClients({ isCombo: true, companiaId: companyId }, 1)
    if (data.length === 1) {
      setValue('ClienteId', data[0].value as string)
      setError('ClienteId', {})
      await getSitesFn(data[0].value as string)
    }
    setClient(data)
  }

  const getSitesFn = async (clientId: string) => {
    const data = await getSites(
      { isCombo: true, clienteId: clientId, companiaId: watch('CompaniaId') },
      1,
    )
    if (data.length === 1) {
      setValue('SiteId', data[0].value as string)
      setError('SiteId', {})
      await getCampsFn(data[0].value as string)
    }
    setSite(data)
  }

  const getCampsFn = async (siteId: string) => {
    const data = await getCamps(
      {
        isCombo: true,
        siteId: siteId,
        companiaId: watch('CompaniaId'),
        clienteId: watch('ClienteId'),
      },
      1,
    )
    if (data.length === 1) {
      setValue('CampamentoId', data[0].value as string)
      setError('CampamentoId', {})
      await getModulesFn(data[0].value as string)
    }
    setCamp(data)
  }

  const getModulesFn = async (campId: string) => {
    const data = await getModules({
      CampamentoId: campId,
      CompaniaId: watch('CompaniaId'),
      ClienteId: watch('ClienteId'),
      SiteId: watch('SiteId'),
    })
    setModules(data)
  }

  useEffect(() => {
    getCompaniesFn()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getData = async (datafilter: any = null) => {
    try {
      setLoading(true)
      const formValues = watch()
      const obj: any = {
        CampamentoId: formValues.CampamentoId || null,
        ModuloId: formValues.ModuloId || null,
      }
      const formValue = { pageNumber: 1, size: 10, ...obj, ...searchValues, ...datafilter }
      setDtoToSend(formValue)
      const { data: response } = await getListCamasPreferentesService(formValue)
      if (!response.error) {
        setTotal(response.total || response.data?.length || 0)
        setDataTable(response.data || [])
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
      getSnackBarToast('Error al obtener los datos', 'error')
    }
  }

  const onSubmit = (dataForm: any) => {
    const formValues = watch()
    const obj: any = {
      CampamentoId: formValues.CampamentoId || null,
      ModuloId: formValues.ModuloId || null,
    }
    const formValueToSend = { pageNumber: 1, size: 10, ...obj, ...searchValues }
    setDtoToSend(formValueToSend)
    getData()
  }

  const handleExportExcel = async () => {
    try {
      if (!dtoToSend) {
        getSnackBarToast('Debe realizar una búsqueda primero', 'warning')
        return
      }
      setLoading(true)
      const obj: any = {
        CampamentoId: dtoToSend.CampamentoId || null,
        ModuloId: dtoToSend.ModuloId || null,
      }
      const response = await downloadCamasPreferentesExcelService(obj)
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `Reporte_Camas_Preferentes_${new Date().getTime()}.xlsx`)
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
      getSnackBarToast('Archivo descargado con éxito', 'success')
      setLoading(false)
    } catch (error) {
      setLoading(false)
      getSnackBarToast('Error al exportar el archivo', 'error')
    }
  }

  const handleFilterClient = (e: any) => {
    let value = e.value
    setValue('ClienteId', '')
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    setValue('ModuloId', '')
    getClientsFn(value)
    setValue('CompaniaId', value)
    setError('CompaniaId', {})
    setClient([])
    setSite([])
    setCamp([])
    setModules([])
  }

  const handleFilterSite = (e: any) => {
    let value = e.value
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    setValue('ModuloId', '')
    getSitesFn(value)
    setValue('ClienteId', value)
    setError('ClienteId', {})
    setSite([])
    setCamp([])
    setModules([])
  }

  const handleFilterCamp = (e: any) => {
    let value = e.value
    setValue('CampamentoId', '')
    setValue('ModuloId', '')
    getCampsFn(value)
    setValue('SiteId', value)
    setError('SiteId', {})
    setCamp([])
    setModules([])
  }

  const handleFilterModule = (e: any) => {
    let value = e.value
    setValue('ModuloId', '')
    setValue('CampamentoId', value)
    setError('CampamentoId', {})
    getModulesFn(value)
  }

  const handleClear = () => {
    reset()
    setClient([])
    setSite([])
    setCamp([])
    setModules([])
    setDataTable([])
    setDtoToSend(null)
    getCompaniesFn()
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='p-6'>
          <FormProvider {...methods}>
            <form className='m-2'>
              <div className='row'>
                <div className='col-sm-12 col-lg-3'>
                  <SelectWrapper
                    name='CompaniaId'
                    labelText='Compañía'
                    data={compani}
                    onChangeValue={handleFilterClient}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <SelectWrapper
                    name='ClienteId'
                    labelText='Cliente'
                    data={client}
                    onChangeValue={handleFilterSite}
                    disabled={!watch('CompaniaId') || watch('CompaniaId') === ''}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <SelectWrapper
                    name='SiteId'
                    labelText='Site'
                    data={site}
                    onChangeValue={handleFilterCamp}
                    disabled={!watch('ClienteId') || watch('ClienteId') === ''}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <SelectWrapper
                    name='CampamentoId'
                    labelText='Campamento'
                    data={camp}
                    onChangeValue={handleFilterModule}
                    disabled={!watch('SiteId') || watch('SiteId') === ''}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <SelectWrapper
                    name='ModuloId'
                    labelText='Módulo'
                    data={modules}
                    disabled={!watch('CampamentoId') || watch('CampamentoId') === ''}
                  />
                </div>
              </div>
              <ButtonWrapper className={'sdx-white-bg'}>
                <Button label='Buscar' onClick={handleSubmit(onSubmit)} />
                <Button label='Limpiar' onClick={handleClear} />
                <Button label='Exportar Excel' onClick={handleExportExcel} disabled={!dtoToSend || loading} loading={loading} />
              </ButtonWrapper>
            </form>
          </FormProvider>
        </div>
        <div className='p-6'>
          <TableReportCamasPreferentes
            datos={dataTable}
            loading={loading}
            getData={getData}
            formValue={dtoToSend}
            total={total}
          />
        </div>
      </KTCard>
    </>
  )
}

export { ReportCamasPreferentes }
